var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ElementsSizeProvider", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ setSize, getBlockMinHeight }) {
          return [
            _c(
              "div",
              { staticClass: "flex flex-row flex-wrap gap-4 mb-8" },
              _vm._l(_vm.projects, function (project, index) {
                return _c("ProjectsListCard", {
                  key: project.id,
                  attrs: {
                    project: project,
                    companyId: _vm.companyId,
                    currentUser: _vm.currentUser,
                    hideManager: _vm.hideManager,
                    descriptionBlockHeight: getBlockMinHeight({
                      id: project.id,
                      blockName: "description",
                      index,
                    }),
                  },
                  on: {
                    "update:descriptionBlockHeight": (minHeight) =>
                      setSize({
                        id: project.id,
                        blockName: "description",
                        minHeight,
                        index,
                      }),
                    projectUpdated: function ($event) {
                      return _vm.$emit("projectUpdated")
                    },
                  },
                })
              }),
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }